import { gql } from '@apollo/client';

export const GET_TEAMS = gql`
  query RostersByIds($rosterIds: [String!]!) {
    rostersByIds(rosterIds: $rosterIds) {
      groupId
      groupName
    }
  }
`;
